import { useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import { getActiveLanguage } from 'b2b-apps/shop/i18n/redux/selectors';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

export const useActiveLanguage = (): LANGUAGE_CODE => useSelector(getActiveLanguage, isEqual);
